module.exports = "/packs/media/images/investing_mobile-3bf2b02f267ed5a419c19688f4f40848.jpg";